import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import {
  crearHorariosVacios,
  normalizarHorariosAtencion,
  obtenerEstadoTienda,
} from "../utils/horariosAtencion";

export const CONFIG_NEGOCIO_DEFAULT = {
  nombreNegocio: "Mítico Amorcito",
  telefonoNegocio: "",
  direccionNegocio:
    "Av. Aurelio Ortega 863, Jardines de La Seattle, Zapopan, Jalisco, 45150",
  latNegocio: 20.73081,
  lngNegocio: -103.38827,
  logoUrl: "/logo-mitico.png",
  logoAnchoPx: 120,
  logoAltoMaxPx: 42,
  radioEntregaKm: 8,
  costoEnvioBase: 35,
  costoEnvioPorKm: 15,
  kmIncluidosEnvio: 3,
  horariosAtencion: crearHorariosVacios(),
};

const obtenerNumero = (valor, respaldo) => {
  if (valor === undefined || valor === null || valor === "") return respaldo;

  const numero = Number(valor);

  return Number.isNaN(numero) ? respaldo : numero;
};

const construirConfiguracionNegocio = (data = {}) => {
  const horariosNormalizados = normalizarHorariosAtencion(
    data.horariosAtencion,
  );

  return {
    ...CONFIG_NEGOCIO_DEFAULT,
    ...data,
    nombreNegocio: data.nombreNegocio || CONFIG_NEGOCIO_DEFAULT.nombreNegocio,
    telefonoNegocio:
      data.telefonoNegocio || CONFIG_NEGOCIO_DEFAULT.telefonoNegocio,
    direccionNegocio:
      data.direccionNegocio || CONFIG_NEGOCIO_DEFAULT.direccionNegocio,
    latNegocio: obtenerNumero(
      data.latNegocio,
      CONFIG_NEGOCIO_DEFAULT.latNegocio,
    ),
    lngNegocio: obtenerNumero(
      data.lngNegocio,
      CONFIG_NEGOCIO_DEFAULT.lngNegocio,
    ),
    logoUrl: data.logoUrl || CONFIG_NEGOCIO_DEFAULT.logoUrl,
    logoAnchoPx: obtenerNumero(
      data.logoAnchoPx,
      CONFIG_NEGOCIO_DEFAULT.logoAnchoPx,
    ),
    logoAltoMaxPx: obtenerNumero(
      data.logoAltoMaxPx,
      CONFIG_NEGOCIO_DEFAULT.logoAltoMaxPx,
    ),
    radioEntregaKm: obtenerNumero(
      data.radioEntregaKm,
      CONFIG_NEGOCIO_DEFAULT.radioEntregaKm,
    ),
    costoEnvioBase: obtenerNumero(
      data.costoEnvioBase,
      CONFIG_NEGOCIO_DEFAULT.costoEnvioBase,
    ),
    costoEnvioPorKm: obtenerNumero(
      data.costoEnvioPorKm,
      CONFIG_NEGOCIO_DEFAULT.costoEnvioPorKm,
    ),
    kmIncluidosEnvio: obtenerNumero(
      data.kmIncluidosEnvio,
      CONFIG_NEGOCIO_DEFAULT.kmIncluidosEnvio,
    ),
    horariosAtencion: horariosNormalizados,
  };
};

function useConfiguracionNegocio() {
  const [configuracionNegocio, setConfiguracionNegocio] = useState(
    CONFIG_NEGOCIO_DEFAULT,
  );

  const [cargandoConfiguracion, setCargandoConfiguracion] = useState(true);
  const [fechaRevisionTienda, setFechaRevisionTienda] = useState(new Date());

  useEffect(() => {
    const configRef = doc(db, "configuracion", "negocio");

    const unsubscribe = onSnapshot(
      configRef,
      (configSnap) => {
        if (!configSnap.exists()) {
          setConfiguracionNegocio({
            ...CONFIG_NEGOCIO_DEFAULT,
            horariosAtencion: crearHorariosVacios(),
          });

          setCargandoConfiguracion(false);
          return;
        }

        const data = configSnap.data();

        setConfiguracionNegocio(construirConfiguracionNegocio(data));
        setCargandoConfiguracion(false);
      },
      (error) => {
        console.error("Error escuchando configuración del negocio:", error);

        setConfiguracionNegocio({
          ...CONFIG_NEGOCIO_DEFAULT,
          horariosAtencion: crearHorariosVacios(),
        });

        setCargandoConfiguracion(false);
      },
    );

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const intervalo = setInterval(() => {
      setFechaRevisionTienda(new Date());
    }, 60000);

    return () => clearInterval(intervalo);
  }, []);

  const estadoTienda = obtenerEstadoTienda(
    configuracionNegocio.horariosAtencion,
    fechaRevisionTienda,
  );

  return {
    configuracionNegocio,
    cargandoConfiguracion,
    estadoTienda,
  };
}

export default useConfiguracionNegocio;
